<template>
  <div class="basic_login_index">
    <div class="tooptipPart" >
      <my_edit_btn :module="module" :title="$t('widgets_basic_article_classification_index_336')"></my_edit_btn>
      <!-- <my_close_btn
          :module="module"
          :column="column"
          :moduleIndex="module_index"
          title="删除模块"
          v-if="$store.state.app.view_pattern === 'pc'"
        ></my_close_btn> -->
    </div>
    <!-- login-model-0  login-model-1 login-model-2 -->
    <div class="login-container" :class="[$store.state.app.view_pattern =='pc'?`login-model-${listArr.module_style}`: 'login-model-1 login-model-mb']" >
        <div class="img-model" v-if="listArr.module_style !== '0' && $store.state.app.view_pattern =='pc'">
          <img :src="infor.img" alt="" class="img">
        </div>
        <!-- 手机端图片 -->
        <div class="img-model" v-if="!isPc">
          <img :src="infor.img" alt="" class="img">
        </div>
       <div class="login-content" :style=" {
          '--placeholderColor': placeholderColor,
          '--btnBgColor':background_button,
          '--inputBg': background_input,
          '--inputFontSize': font_login_item_content.fontSize,
          '--inputFontFamaily':font_login_item_content.fontFamily,
          '--btnFontColor':button_font.color,
          '--smallFontSize':smallFontSize,
          '--inputBorderColor':input_border_color
        }">
         <div class="login-content-inner">
           <!-- <div class="login-title" :style="{...font_login_name}">登录</div> -->
          <my_title_index :title="infor.title" class="content-title"></my_title_index>
          <!-- 请输入账号 -->
          <div class="input-list" >
            <div class="input-label" :style="{...font_login_item_title}" v-if="listArr.module_style === '1' || !isPc">{{login_type==='username'? $t('widgets_basic_login_index_2563'): login_type==='phone'? $t('base_options_config_1784'): $t('widgets_basic_job_components_table1_2523')}}</div>
            <input disabled type="text" class="input" :style="{ ...font_login_item_content,background:background_input}" ::placeholder="$t('widgets_basic_login_index_2564', [login_type==='username' ? $t('widgets_basic_login_index_2563') : login_type==='phone'? $t('base_options_config_1784') : $t('widgets_basic_job_components_table1_2523')])">
          </div>
          <!-- v-if="login_type!=='phone'":style="{display: login_type!=='phone' ? 'block' : 'none'}" -->
          <div class="input-list input-password" v-show="login_type!=='phone'">
            <div class="input-label" v-if="listArr.module_style === '1' || !isPc" :style="{...font_login_item_title}">{{$t('view_login_index_33')}}</div>
            <input autocomplete="new-password" disabled type="password" class="input" :style="{...font_login_item_content,background:background_input}" :placeholder="$t('widgets_basic_login_index_2565')">
              <i class="fa fa-low-vision icon-eye"></i>
              <!-- <i class="fa fa-eye-slash icon-eye"></i>  -->
          </div>
          
           <!-- 滑动登录 -->
          <div class="input-list" :class="[input_color?'input-list-color': 'input-list-image']">
            <div id="nc" class="input-nc" ref="slider" ></div>
          </div>
          <!-- 请输入验证码 v-if="login_type==='phone'"  -->
          <div class="input-list" v-if="login_type==='phone'">
            <div class="input-label" v-if="listArr.module_style === '1'" :style="{...font_login_item_title}">{{$t('widgets_basic_login_index_2566')}}</div>
            <div class="input-list-code">
              <input type="text" class="input input-code" :style="{...font_login_item_content,background:background_input}" :placeholder="$t('view_login_index_47')">
              <button class="input-btn" :style="{...button_font,backgroundColor:background_button,borderRadius:button_border_radius, fontSize: '16px'}">{{$t('components_verificationbutton_index_2494')}}</button>
            </div>
          </div>
          <div class="btn-set" :class="{'btn-set-flex':listArr.module_style !== '0' && isPc}">
             <!-- 登录按钮 -->
            <div class="input-list input-list-margin">
              <button class="login-btn" :style="{...button_font,background:background_button,borderRadius:button_border_radius}">{{$t('view_login_index_34')}}</button>
            </div>
            <!-- 注册按钮 -->
            <div class="input-list input-list-margin">
              <button class="login-btn register-btn" :style="{
                ...button_font,
                 background: background_button_register,
                 color:pc_widgets_infor.button_set.font[pc_widgets_infor.button_set.font.radio_val].registerColor,
                 borderColor:background_button,
                 borderColor:pc_widgets_infor.button_set.borderColor[pc_widgets_infor.button_set.borderColor.radio_val].color,
                 borderRadius:button_border_radius
                }" @click="goLink('/user_register')">{{$t('router_default_91')}}</button>
            </div>
          </div>
          <!-- 忘记密码 登录选项 -->
          <div class="last-input">
            <p class="forget-txt" @click="goLink('/user_forget')" v-if="login_type!=='phone'">{{$t('widgets_basic_login_index_2567')}}</p> 
            <div class="login-list">
              <div class="login-type"  v-for="login in login_list_new" :key="login.id" @click="loginToggle(login.id)">{{login.value}}</div>
            </div>
          </div>
         </div>
         
       </div>
    </div>
    <!-- 显示 弹框 提示 去修改 完善信息 -->
    <div class="login-tip-content">
      <div class="opc"></div>
      <div class="login-tip">
        <div class="tip-title">
          <i class="close-icon">×</i>
        </div>
        <div class="tip-content">
          <i class="fa fa-exclamation-circle warning-icon" ></i>
          <p class="tip-desc">{{$t('widgets_basic_login_index_2568')}}</p>
          <div class="tip-txt">{{$t('widgets_basic_login_index_2569')}}</div>
          <div class="tip-btn">
            <button class="btn-link">{{$t('widgets_basic_login_index_2570')}}</button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  <!-- height_fill -->
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import {background_color, font_set} from '@/base/background_set';
/* import {getUserLoginWay} from "@/api/app"; */
export default {
  name: 'basic_login',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
    }
  },
  created() {
    this.colorInit()
  },
  mounted(){
    this.init();
    this.loginType()
  },
  computed: {
    login_type(){
      return this.listArr.login_type
    },
    login_list() {
      return this.listArr.login_list
    },
    login_list_new(){
      return this.login_list.filter(item => item.id !==this.login_type && item.isShow)
    },
    listArr(){
      return this.module.data.listArr
    },
    infor() {
      return this.module.data[
        this.$store.state.app.view_pattern + "_widgets_infor"
      ];
    },
    pc_widgets_infor() {
       return this.module.data.pc_widgets_infor
    },
    mb_widgets_infor() {
       return this.module.data.mb_widgets_infor
    },
    background_input(){ // 输入框的背景颜色
      return background_color(this.pc_widgets_infor.login_input)
    },
    /* font_login_name(){ // 标题的颜色 字体
      return font_set(this.pc_widgets_infor.login_name)
    }, */
    font_login_item_title(){ // 登录标题项的 字体设置
      return font_set(this.pc_widgets_infor.login_item_title)
    },
    
    font_login_item_content(){ // 登录项内容
      return font_set(this.pc_widgets_infor.login_item_content)
    },
    input_border_color() {
      // console.log(777,this.pc_widgets_infor.borderColor)
      return this.pc_widgets_infor.borderColor[this.pc_widgets_infor.borderColor.radio_val].color
    },
    input_color() {
      return this.pc_widgets_infor.login_item_content[this.pc_widgets_infor.login_item_content.radio_val].pattern=== 'pure_color'
    },
    placeholderColor(){
      return this.font_login_item_content.color
    },
    smallFontSize() {
      let num = Number(this.font_login_item_content.fontSize.slice(0,-2))-2
      return `${num}px`
    },
    background_button() { // 按钮的背景 登录按钮的默认背景色始终是背景色
      return background_color(this.pc_widgets_infor.button_set.background, 'bgColor_globalColor')
    },
    background_button_register() { // 按钮的背景 注册 background_register 注册背景的选项始终和登录背景的选项一致
      this.pc_widgets_infor.button_set.background_register.radio_val = this.pc_widgets_infor.button_set.background.radio_val
      return background_color(this.pc_widgets_infor.button_set.background_register)
    },
    button_font() { // 按钮字体的设置
      return font_set(this.pc_widgets_infor.button_set.font)
    },
    button_border_radius(){ // 按钮的圆角
      return `${this.pc_widgets_infor.button_set.borderRadius[this.pc_widgets_infor.button_set.borderRadius.radio_val].value}px`
    },
    isPc() {
      return this.$store.state.app.view_pattern =='pc'
    },
    theme_color () {
      return this.$store.state.myRender.common.theme_color
    }
  },
  methods: {
    init(){
      AWSC.use("nc", function (state, module) {
        // 初始化
        window.nc = module.init({
            // width:94,
            // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
            appkey: "CF_APP_1",
            //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
            scene: "register",
            // 声明滑动验证需要渲染的目标ID。
            renderTo: "nc",
            //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
            success: function (data) {
                window.console && console.log(data.sessionId)
                window.console && console.log(data.sig)
                window.console && console.log(data.token)
            },
            // 滑动验证失败时触发该回调参数。
            fail: function (failCode) {
                 window.console && console.log(failCode)
            },
            // 验证码加载出现异常时触发该回调参数。
            error: function (errorCode) {
                 window.console && console.log(errorCode)
            }
        });
    })
    },
    colorInit() {
      this.pc_widgets_infor.title.font.default.fontColor_globalColor = this.theme_color // 标题栏的默认颜色取的是主题色 PC 
      this.mb_widgets_infor.title.font.default.fontColor_globalColor = this.theme_color // 标题栏的默认颜色取的是主题色 手机
      this.pc_widgets_infor.button_set.background.default.bgColor_globalColor = this.theme_color // 登录按钮的背景色默认颜色始终是 bgColor__globalColor
    },
    loginType() { // 登录方式
      let arr = this.$store.state.login_type.login_type
      /* let arr = this.$store.state.login_type.login_type
      arr.forEach((key, i) => {
        let index = this.listArr.login_list.findIndex(item => item.id ===key)
        this.listArr.login_list[index].isShow = true
        if(i === 0)this.listArr.login_type = key
      }) */
      if(arr.length > 0) {
        this.listArr.login_type = arr[0]
      }
    },
    goLink(path){
      this.$router.push(path)
    },
    loginToggle(id) {
      this.listArr.login_type = id
    }
    /* async getUserLoginConfig(){
      let res = await getUserLoginWay();
      if(res.code === 200){
        let reg_way = res.data.reg_way
        let arr = [];
        for (let key in reg_way) {
          if(reg_way[key])arr.push(key)
        }
        arr.forEach((key, i) => {
          let index = this.listArr.login_list.findIndex(item => item.id ===key)
          this.listArr.login_list[index].isShow = true
          if(i === 0)this.listArr.login_type = key
        })
      } else this.$message.error(res.message)
    } */
  },
  watch: {
    'listArr.module_style'(val){
    }
  }
};
</script>

<style scoped lang="scss">
.basic_login_index{
  .login-container{
    display: flex;
    
    .login-content{
      //width:28%;
      // flex: 1;
      display:flex;
      flex:1;
      .content-title{
        margin-bottom:38px;
        &.my_title_index{
          border-bottom:0;
        }
      }
      .login-title{
        margin-bottom:82px;
      }
      .input-list{
        margin-bottom:28px;
        display: flex;
        flex-direction: column;
        .input{
          // width: 533px;
          // flex: 1;
          width:100%;
          padding: 0 40px;
          padding-left:10px;
          height: 52px;
          // background: #F7F8FB;
          border-radius: 4px;
        }
        &.input-password{
          position: relative;
          .icon-eye{
            position: absolute;
            right:10px;
            bottom: 15px;
            font-size:24px;
          }
        }
        .login-btn{
          width:100%;
          height: 52px;
          border:none;
          &.register-btn{
            border-width: 1px;
            border-style:solid;
            background-color:#fff;
          }
          
        }
        .input-list-code{
          display: flex;
          width:100%;
          .input-code{
            margin-right:12px;
            padding: 0 10px;
            border-radius: 4px;
            flex:1;
          }
          .input-btn{
            border:none;
            flex:1;
           //  width:160px;
          }
        }
        .input-label{
          font-size: 20px;
          font-weight: 400;
          color: #666666;
        }
        /deep/ #nc{
          width:100%;
          position:static;
          .nc_wrapper{
            width:100%;
            height:52px;
            .nc_scale{
              height:52px;
              background: var(--inputBg);
              
              .btn_slide{
                top:0px;
                height:52px;
                line-height:52px;
                width:72px;
                /* border-radius: 4px;
                margin-left:6px; */
                border:none;
                background: var(--btnBgColor);
                color: var(--btnFontColor);
              }
              .slidetounlock{
                line-height:52px;
                font-size:16px;
                padding-left:72px;
                .nc-lang-cnt{
      
                }
              }
            }
          }
        }
        &.input-list-color{
          /deep/ #nc{
            .nc_wrapper{
              .nc_scale{
                .slidetounlock{
                  .nc-lang-cnt{
                    -webkit-text-fill-color: var(--placeholderColor);
                    color: var(--placeholderColor) ;
                    font-size:var(--inputFontSize);
                    font-family: var(--inputFontFamaily);
                    
                  }
                
                }
              }
            }
          }
        }
      }
      .forget-txt{
        margin-bottom: 28px;
        /* font-size: 20px;
        font-weight: 400;
        color: #666666; */
        color: var(--placeholderColor) ;
        font-size:var(--inputFontSize);
        font-family: var(--inputFontFamaily);
      }
      .login-list{
        display: flex;
        justify-content: space-between;
        .login-type{
          /* flex:1; */
         /*  font-size: 20px;
          font-weight: 400;
          color: #666666; */
          color: var(--placeholderColor) ;
          font-size:var(--smallFontSize);
          font-family: var(--inputFontFamaily);
          text-align: left;
        }
      }
    }
    &.login-model-0{
      justify-content: center;
      align-items: center; 
      .login-content{
        justify-content: center;
       
        .login-content-inner{
          width:26%;
          max-width: 500px;
          .input-list{
            .input{
              border:none;
            }
            .input-code{
              border:none
            }
          }
        }
        
      }
    }
    &.login-model-1,&.login-model-2{
      display: flex;
      justify-content: space-between;
      .login-content{
        display: flex;
        flex:1;
        .login-content-inner{
          width:60%;
          .btn-set-flex{
            display: flex;
            .input-list{
              flex:1;
              &:last-child{
                margin-left:30px
              }
            }
          }
        }
      }
      .img-model{
        width:53.5%;
        flex: 0 0 53.5%;
        .img{
          width: 100%;
          object-fit: cover;
        }
      }
    }
    &.login-model-1{
      flex-direction:row-reverse;
      .login-content{
        justify-content: flex-end;
        align-items: center;
        .login-content-inner{
          margin-right:50px;
          .input-list{
            .input{
              border-color:var(--inputBorderColor);
              border-width: 0 0 1px 0;
              border-radius:0;
            }
            #nc{
              border: 1px solid var(--inputBorderColor);
            }
          }
        }
      }
    }
    &.login-model-2{
      flex-direction:row;
      .login-content{
        justify-content: flex-start;
        align-items: center;
        .login-content-inner{
          margin-left:50px;
          .input-list{
            .input{
              // border:none;
              border: 1px solid var(--inputBorderColor);
            }
            .input-code{
              border:none
            }
            #nc{
              border: 1px solid var(--inputBorderColor);
            }
          }
        }
      }
    }
    
  }
  ::-webkit-input-placeholder{
    color: var(--placeholderColor);
    font-size:var(--inputFontSize);
    font-family: var(--inputFontFamaily);
  }    
  :-moz-placeholder{
    color: var(--placeholderColor);
    font-size:var(--inputFontSize);
    font-family: var(--inputFontFamaily);
  }                
  ::-moz-placeholder{
    color: var(--placeholderColor);
    font-size:var(--inputFontSize);
    font-family: var(--inputFontFamaily);
  }                 
  :-ms-input-placeholder{
    color: var(--placeholderColor);
    font-size:var(--inputFontSize);
    font-family: var(--inputFontFamaily);
  }   
  .login-tip-content{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2003;
    overflow: hidden;
    display:none;
    .opc{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.5);
    }
    .login-tip{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      background: #fff;
      width: 360px;
      .tip-title{
        height: 30px;
        padding: 0 20px;
        position: relative;
        .close-icon{
          position: absolute;
          right: 20px;
          top: 0px;
          font-size: 30px;
          cursor: pointer;
        }
      }
      .tip-content{
        margin-top: 30px;
        text-align: center;
        .warning-icon{
          color: #faad14;
          font-size: 46px;
        }
        .tip-desc{
          font-size: 18px;
          font-weight: 700;
          color: #333;
          margin: 28px 0 0 0;
        }
        .tip-txt{
          font-size: 14px;
          padding: 10px 40px;
          color: #666;
          line-height: 26px;
        }
        .tip-btn{
          border-top: 1px solid #e5e5e5;
          padding: 18px 28px;
          margin: 36px 0 0;
          display: flex;
          justify-content: flex-end;
          .btn-link{
            background: #1890ff;
            border: 0;
            color: #fff;
            width: 64px;
            height: 36px;
            line-height: 36px;
            padding: 0;
          }
        }
      }
    }
  }        
}
.pc_pattern{
  .basic_login_index{
    .login-container{
      /* &.login-model-0{
        .login-content{
          width:28%
        }
      } */
      .login-content-inner{
        min-width:300px;
      }
    }
  }
}
.mb_pattern{
  .basic_login_index{
    .login-container{
      &.login-model-mb.login-model-1{
        display: flex;
        flex-direction: column;
        .img-model{
          width:100%;
          // padding-top:100%;
          // position:relative;
          margin-bottom:14px;
          .img{
            // position:absolute;
            width:100%;
            object-fit: cover;
            // height:100%;
            // top:0;
            // left:0;
          }
        }
        .login-content{
          margin-left: 16px;
          margin-right:16px;
          width: calc(100% - 32px);
          .content-title{
            margin-bottom:16px;
            /deep/ .module_banner_text{
              margin-left:0;
            }
          }
          .login-content-inner{
            margin-right:0;
            width:100%;
            .input-list{
              .input{
                border:0;
                border-bottom: 1px solid var(--inputBorderColor);
                border-radius:0;
                padding-left:5px;
              }
              /* #nc{
                border: 1px solid var(--btnBgColor);
                #nc_1_wrapper{
                  .nc_scale{
                    background: var(--inputBg);
                    .slidetounlock{ 
                      .nc-lang-cnt{
                        -webkit-text-fill-color: var(--btnBgColor);
                        color: var(--btnBgColor) ;
                      }
                    }
                  }
                }
              } */
            }
            .last-input{
              display: flex;
              .forget-txt{
                flex: 1;
                font-size:14px;
              }
              .login-list{
                flex: 1;
                .login-type{
                  font-size:14px;
                  text-align: right;
                }
              }
            }
            .btn-set{
              .input-list-margin{
                margin-bottom:15px;
              }
            }
          }
        }
      }
      /* &.login-model-0{
        .login-content{
          width:84%;
          .login-content-inner{
            width:100%;
            margin-left:0;
            margin-right:0;
          }
        }
      } */
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_login/index.vue